export enum PlayerTypeV2Enum {
  POSTUP = 1,
  CREDIT = 2,
  AFFILIATE = 3,
}
